const a={gallery:"galeria",list:"lista",miniature:"miniatura"};export{a as Displays};
